import { ButtonIcon, ButtonSize, ButtonVariant, IconVariants, Input, Shape } from "@next-platform/client-common-spicy-ui";
import { useTranslation } from "@next-platform/client-common-core";
import { useState } from "react";

interface ISearchProps {
  onSearch?: (query: string) => void;
  onClear?: () => void;
  isLoading?: boolean;
}

const Search = ({ onSearch, onClear, isLoading = false }: ISearchProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { t } = useTranslation();
  const handleSearch = () => {
    if (onSearch) {
      onSearch(searchQuery.trim());
    }
  };

  const handleClear = () => {
    setSearchQuery("");
    if (onClear) {
      onClear();
    }
  };

  return (
    <div className="flex flex-row items-center gap-sm my-md">
      <Input
        value={searchQuery}
        onChange={(value: string) => setSearchQuery(value)}
        isClearable={searchQuery.length > 0}
        onClear={handleClear}
        iconStart={IconVariants.MULTI_MESSAGE}
        placeholder={t("chats:page.common.search.placeholder")}
        classNames={{ iconStart: "text-gray-11" }}
      />
      <ButtonIcon
        shape={Shape.SQUARE}
        size={ButtonSize.LARGE}
        variant={ButtonVariant.INVERSE}
        icon={IconVariants.SEARCH}
        loading={isLoading}
        onClick={handleSearch}
      />
    </div>
  );
};

export default Search;
